import { backdropColors } from '@components/layout/colors/backdrop-colors.css'
import { backgroundColors } from '@components/layout/colors/background-colors.css'
import { brandColors } from '@components/layout/colors/brand-colors.css'
import { buttonColors } from '@components/layout/colors/button-colors.css'
import { commonColors } from '@components/layout/colors/common-colors.css'
import { gradientColors } from '@components/layout/colors/gradient-colors.css'
import { homeThemeColorOptions } from '@components/layout/colors/home-theme-color-options'
import { hostLandingThemeColorOptions } from '@components/layout/colors/host-landing-theme-color-options'
import { iconColors } from '@components/layout/colors/icon-colors.css'
import { shadowColors } from '@components/layout/colors/shadow-colors.css'
import { statusColors } from '@components/layout/colors/status-colors.css'
import { textColors } from '@components/layout/colors/text-colors.css'
import { thirdPartyColors } from '@components/layout/colors/third-party-colors.css'

export const palette = {
  home: homeThemeColorOptions.pool,
  hostLanding: hostLandingThemeColorOptions.pool,
  brand: brandColors,
  thirdParty: thirdPartyColors,
  button: buttonColors,
  background: backgroundColors,
  text: textColors,
  icon: iconColors,
  shadow: shadowColors,
  backdrop: backdropColors,
  gradient: gradientColors,
  status: statusColors,
  common: commonColors,
}

/**
 * Before using a name, make sure it is added to /src/components/layout/theme.css.ts
 */
export type PaletteColorNames =
  | `color-home-${keyof typeof palette.home}`
  | `color-hostLanding-${keyof typeof palette.hostLanding}`
  | `color-brand-${keyof typeof palette.brand}`
  | `color-thirdParty-${keyof typeof palette.thirdParty}`
  | `color-button-${keyof typeof palette.button}`
  | `color-background-${keyof typeof palette.background}`
  | `color-text-${keyof typeof palette.text}`
  | `color-icon-${keyof typeof palette.icon}`
  | `color-shadow-${keyof typeof palette.shadow}`
  | `color-backdrop-${keyof typeof palette.backdrop}`
  | `color-gradient-${keyof typeof palette.gradient}`
  | `color-status-${keyof typeof palette.status}`
  | `color-common-${keyof typeof palette.common}`
